import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createContractOffers, getContractOfferSetup, getContractOffers, previewContractOffer,
} from '../../../api/ContractOffers/contractOffers';
import { CreateOffersInput, OfferSetup, PreviewInput, StoredOffer } from '../../../utility/contractOffers';

export function useContractOfferSetup(enabled = true) {
  const query = useQuery({ queryKey: [ 'contractOfferSetup' ], queryFn: () => getContractOfferSetup(), enabled, retry: false });
  return {
    setup: (query.data?.data as OfferSetup & { success: boolean }) || null,
    isLoading: query.isLoading,
    error: query.error,
  };
}

// Stored contracts I may see for the properties in one list
export function useStoredContractOffers(listSortId: string | undefined) {
  const query = useQuery({
    queryKey: [ 'contractOffers', listSortId ],
    queryFn: () => getContractOffers(listSortId as string),
    enabled: !!listSortId,
    retry: false,
  });
  return { offers: (query.data?.data.results as StoredOffer[]) || [], isLoading: query.isLoading };
}

export function usePreviewContractOffer() {
  return useMutation({ mutationFn: (input: PreviewInput) => previewContractOffer(input) });
}

export function useCreateContractOffers() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateOffersInput) => createContractOffers(input),
    // Even a partly failed batch may have stored some contracts
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [ 'contractOffers' ] });
      queryClient.invalidateQueries({ queryKey: [ 'contractOfferSetup' ] });
    },
  });
}
